import PropTypes from "prop-types";
import {
  Alert,
  Badge,
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";

import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

export default function BookingsModal({
  open,
  onClose,
  bookings,
  offerIndicators = {},
  onView,
  loading,
  error,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: (theme) => ({
          [theme.breakpoints.down("sm")]: {
            width: "95%",
            maxWidth: "95%",
            mx: "auto",
          },
        }),
      }}
    >
      <DialogTitle>Mis pedidos en curso ({bookings.length})</DialogTitle>
      <DialogContent dividers>
        {error && <Alert severity="error">{error}</Alert>}
        {loading && <Typography>Cargando pedidos...</Typography>}
        {!loading && !error && bookings.length === 0 && (
          <Typography>No tienes pedidos inmediatos.</Typography>
        )}
        <Stack spacing={2}>
          {bookings.map((booking) => (
            <Card key={booking.firebaseKey} variant="outlined">
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <Typography fontWeight={800}>
                    TM-{booking.counterBooking}
                  </Typography>
                  {offerIndicators[booking.uuid]?.count > 0 && (
                    <Tooltip title="Ofertas disponibles">
                      <Badge
                        badgeContent={offerIndicators[booking.uuid].count}
                        color="error"
                        role="status"
                        aria-label={`${offerIndicators[booking.uuid].count} ofertas disponibles para el pedido TM-${booking.counterBooking}`}
                      >
                        <NotificationsActiveIcon color="success" />
                      </Badge>
                    </Tooltip>
                  )}
                  <Button variant="contained" onClick={() => onView(booking)}>
                    Ver
                  </Button>
                </Box>
                {offerIndicators[booking.uuid]?.error && (
                  <Typography
                    variant="caption"
                    color="warning.main"
                    role="status"
                  >
                    {offerIndicators[booking.uuid].error}
                  </Typography>
                )}
                <Typography>
                  <span style={{ fontWeight: "bold" }}>Pasajero: </span>{" "}
                  {booking.otherPersonName || booking.clientName}
                </Typography>
                <Typography>
                  <span style={{ fontWeight: "bold" }}> Origen:</span>{" "}
                  {booking.origin?.name}
                </Typography>
                <Typography>
                  <span style={{ fontWeight: "bold" }}> Destino: </span>{" "}
                  {booking.destination?.name}
                </Typography>
                <Typography variant="body2">
                  {Number(booking.idDriver) > 0
                    ? "Conductor asignado"
                    : "Buscando conductor"}{" "}
                  · {booking.date} {booking.time}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Crear otro pedido
        </Button>
        <Button onClick={onClose} variant="contained" color="error">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
BookingsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  bookings: PropTypes.array.isRequired,
  offerIndicators: PropTypes.object,
  onView: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.string,
};
